import { mediaGenerateUploadUrlMutation } from '$api-client/@tanstack/react-query.gen'
import { MediaObject } from '$api-client/types.gen'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'

export function useFileUpload() {
  const [uploadingStatus, setUploadingStatus] = useState<Record<string, boolean>>({})
  const [files, setFiles] = useState<Record<string, MediaObject>>({})

  const { mutateAsync: generateUploadUrl } = useMutation({
    ...mediaGenerateUploadUrlMutation(),
  })

  const isUploading = (name?: string): boolean => {
    if (!name) {
      return Object.values(uploadingStatus).some(status => status)
    }

    return !!uploadingStatus[name]
  }

  const getFile = (name: string): MediaObject | undefined => {
    return files[name]
  }

  const uploadFile = async (name: string, file?: File) => {
    if (!file) {
      setFiles(prevFiles => {
        const newFiles = { ...prevFiles }
        delete newFiles[name]
        return newFiles
      })
      return
    }

    setUploadingStatus(prev => ({ ...prev, [name]: true }))

    const { data } = await generateUploadUrl({
      body: {
        file_extension: file.name.split('.').pop()!,
        content_type: file.type,
      },
    })

    await fetch(data.url, {
      method: 'PUT',
      body: file,
    })

    setFiles(prevFiles => ({
      ...prevFiles,
      [name]: data,
    }))
    setUploadingStatus(prev => ({ ...prev, [name]: false }))
  }

  return {
    isUploading,
    uploadFile,
    getFile,
    files,
  }
}
